import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { attach } from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import MapApi from '@mgc/map-client-shared/lib/MapApi';
import selectors from '../selectors';
import UiActions from '../actions/ui';
import utils from '../utils';
import strings from '../strings';
import MapPropTypes from './MapPropTypes';
import AccountModal from './Modals/AccountModal';
import TransactionModal from './Modals/TransactionModal';
import ShoppingCartModal from './Modals/ShoppingCartModal';
import HelpModal from './Modals/HelpModal';
import './Header.scss';

class Header extends Component {
    static propTypes = {
        offer: MapPropTypes.OfferProps,
        myself: MapPropTypes.UserProps,
        spoofer: MapPropTypes.UserProps,
        cart: MapPropTypes.CartProps,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            offer: selectors.offer.getSelectedOffer,
            myself: selectors.user.getMyself,
            spoofer: selectors.user.getSpoofer,
            cart: selectors.cart.getCartContents,
            isLoggedIn: selectors.login.getIsLoggedIn,
        });

    static mapDispatch = (dispatch) => ({
        openModal: (modal) => dispatch(UiActions.openModal(modal)),
        openHelpModal: () => dispatch(UiActions.openHelpModal()),
    });

    _renderButton() {
        if (!this.props.isLoggedIn) {
            return <span />;
        }

        return (
            <button
                className="btn btn-need-help btn-sm help-button"
                onClick={() => this.props.openHelpModal()}
            >
                {strings.needHelpQuestion}
            </button>
        );
    }

    _renderBalance() {
        if (!this.props.offer) {
            return null;
        }

        const balance = utils.formatPrice(this.props.offer.balance);

        return (
            <div className="navbar-flex-addon p-lg-r-md">
                <a
                    onClick={() => this.props.openModal('transaction')}
                    className="btn btn-sm btn-opaque-dark transaction-button"
                >
                    <b className="text-xs text-mute text-uppercase">
                        {strings.myBalance}:
                    </b>
                    {' ' + balance}
                </a>
            </div>
        );
    }
    _renderCart() {
        if (!this.props.offer) {
            return null;
        }
        const { cartItemCount, saveForLaterCount } = this.props.cart.reduce((counts, item) => {
            if (item.cartId != ''){
                if (!item.saveForLater) counts.cartItemCount++;
                else counts.saveForLaterCount++;
            }             
            return counts;
          }, { cartItemCount: 0, saveForLaterCount: 0 });
        // displaying item count for items which are not saved for later and added to cart.   
        const isDisabled = (cartItemCount === 0 && saveForLaterCount === 0);
    
        return (
            <div className="navbar-flex-addon p-lg-r-md">
                {/* Cart Icon with onClick, disabled if cart is empty */}
                <a
                    onClick={(e) => {
                        if (isDisabled) {
                            e.preventDefault();  // Prevent the default action if disabled
                        } else {
                            this.props.openModal('shoppingcart');  // Open the modal if not disabled
                        }
                    }}
                    className={`btn btn-sm btn-opaque-dark cart-button ${isDisabled ? 'disabled' : ''}`}  // Add disabled class for styling
                    style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}  // Disable pointer events if cart is empty
                >
                    <span className="cart-icon">
                        <svg className="icon icon-plm-shopping-cart">
                            <use href="#icon-plm-shopping-cart" />
                        </svg>
                    </span>
    
                    {/* Display cart count, defaulting to 0 if no items */}
                    <span className="cart-count">
                        {cartItemCount}
                    </span>
                </a>
            </div>
        );
    }    

    _renderLogoutLink() {
        const { myself, spoofer } = this.props;
        if (!myself) {
            return null;
        }

        let icon = 'icon-user';
        let iconClass = '';
        let labelClass = 'text-muted';

        if (spoofer) {
            icon = 'icon-users';
            iconClass = 'text-success';
            labelClass = 'text-success';
        }

        return (
            <div className="navbar-flex-addon">
                <span className="text-xs">
                    <a
                        className="cursor-pointer account-button"
                        onClick={() => this.props.openModal('account')}
                    >
                        <span className={iconClass}>
                            <svg className={`icon icon-circle-border ${icon}`}>
                                <use href={`#${icon}`} />
                            </svg>
                        </span>
                        <span className={labelClass}>
                            {` ${myself.firstName} ${myself.lastName}`}
                        </span>
                    </a>
                    <span className="text-pipe"> | </span>
                    <a className="logout-link" href={MapApi.getLogoutUrl()}>
                        {strings.signOut}
                    </a>
                </span>
            </div>
        );
    }

    render() {
        return (
            <nav className="navbar navbar-top navbar-top-no-shadow navbar-flex text-webfont-one p-a-sm text-inverse header">
                <div className="navbar-flex-addon">
                    <a className="logo-mentor" href="#" />
                </div>
                <div className="navbar-flex-addon p-l">
                    <h1 className="h4 m-a-0">{strings.mentorAdvantage}</h1>
                </div>
                <div className="navbar-flex-addon p-l">
                    <div className="item-flex-addon text-xs text-muted">
                            {this._renderButton()}
                    </div>
                </div>
                <div className="navbar-flex-main" />
                {this._renderBalance()}
                {this._renderCart()}
                {this._renderLogoutLink()}
                 <HelpModal /> {/* redux connected */}
                <AccountModal />
                {/* redux connected */}
                <TransactionModal />
                {/* redux connected */}
                <ShoppingCartModal /> {/* redux connected */}
            </nav>
        );
    }
}

export default attach(Header);



// WEBPACK FOOTER //
// ./app/components/Header.jsx